import React, { useEffect, useState } from "react";
import {
  MainButton,
  MainLink,
  Subtitle,
  TextBold,
  Title,
} from "../../styles/GlobalStyledComponents";
import UnavailableImgSrc from "../../assets/images/personal-finances-unavailable/BelenderUnavailableImg.png";
import { TextTel, UnavailableContainer, UnavailableImage, UnavailableImageWrapper, UnavailableLink } from "./StyledComponent";
import { useMerchant } from "../../contexts/MerchantContext";
import PostMessageService from "../../services/PostMessage";
import ViewModeService from "../../services/ViewMode";
import { useLocation, useNavigate } from "react-router-dom";
import { useCreditProposalResult } from "../../contexts/CreditProposalResultContext";
import AnalyticsService from "../../services/Analytics";
import { BelenderType, DenialStep } from "../../interfaces/Analytics";
import { CreditProposalFlowStep, CreditProposalResult } from "../../interfaces/CreditProposalResult";
import { ROUTES_PATH } from "../../constants";
import { CustomerClassification, CustomerClassificationEnum } from "../../interfaces/CustomerClassification";
import CreditProposalService from "../../services/CreditProposal";
import InsightService from "../../services/Insight";
import { DecisionStatus } from "../../interfaces/DecisionEngine";
import { useCustomerClassification } from "../../contexts/CustomerClassificationContext";

interface UnavailableProps {
  loadingEvent: (data: boolean) => void;
}

interface ErrorTypeState {
  errorType?: string;
}

export const PersonalFinancesUnavailable: React.FC<UnavailableProps> = ({
  loadingEvent,
}) => {
  const navigate = useNavigate();
  const { creditProposalResult, createCreditProposalResult } =
    useCreditProposalResult();
  const { isNemuru, isPostDataMessages } = useMerchant();
  const location = useLocation();
  const { errorType } = (location.state as ErrorTypeState) || {};
  console.log('errorType', errorType)
  const [isApp, setisApp] = useState<boolean>(false);
  const [device, setDevice] = useState<string | null>(null);
  const customerDevice = ViewModeService.getDevice();
  const handleClose = () => {
    if (isApp && device === "android") {
      window.location.href = "peppermerchants://home";
    } else {
      PostMessageService.closeCEX();
    }
  };
  const { createCustomerClassification } = useCustomerClassification();

  const getDecisionData = async (
    creditProposalDecision: CreditProposalResult,
    counter: number,
    step?: string,
  ) => {

    counter++;
    try {
      const decisionResp = await CreditProposalService.getDecision(
        creditProposalDecision.credit_proposal_id,
      );
      if (decisionResp) {
        switch (decisionResp.decision) {
          case DecisionStatus.APPROVED:
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              if (
                creditProposalDecision.customer?.require_documentation &&
                !creditProposalDecision.ocr_id &&
                creditProposalDecision.product !== 'PLS'
              ) {
                navigate(ROUTES_PATH.OCR);
              } else if (creditProposalDecision.product === 'PLS') {
                navigate(ROUTES_PATH.BANKREADER);
              } else {
                navigate(ROUTES_PATH.PAYMENT);
              }
            } else if (step === 'DECISION_PAC') {
              navigate(ROUTES_PATH.SIGNATURE);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case DecisionStatus.ALTERNATIVE_OFFER:
          case DecisionStatus.COUNTER_OFFER: // Contraoferta
            if (
              decisionResp.counter_offers &&
              decisionResp.counter_offers.length > 0
            ) {
              createCreditProposalResult({
                ...creditProposalDecision,
                counter_offers: decisionResp.counter_offers,
              } as CreditProposalResult);
            }
            navigate(ROUTES_PATH.COUNTER_OFFER);
            break;
          case DecisionStatus.DENIED:
            navigate(ROUTES_PATH.DENIAL);
            break;
          case DecisionStatus.MISSING_DATA:
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            break;
          default:
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            break;
        }
      }
    } catch (error) {
      if (`${error}`.includes('409') && counter <= 11) {
        setTimeout(() => {
          getDecisionData(creditProposalDecision, counter, step);
        }, 3000);
      } else {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };
  const getClassification = async (creditProposalnew: CreditProposalResult) => {
    try {
      const classification = await CreditProposalService.postClassification(
        creditProposalnew.credit_proposal_id,
        creditProposalnew,
      );
      createCustomerClassification(classification);
      if (
        classification.customer_classification ===
        CustomerClassificationEnum.denied
      ) {
        AnalyticsService.sendLoanRefused({ denial_step: DenialStep.CUST });
        navigate(ROUTES_PATH.DENIAL);
      } else if (
        classification.require_labor_data ||
        classification.require_address_data
      ) {
        navigate(ROUTES_PATH.LABOR_DATA);
      } else {
        getDecisionData(creditProposalnew, 0);
      }
    } catch (error: any) {
      if (
        error &&
        error.response?.data?.result?.errors.find(
          (er: any) => er.code === 'DRF0089',
        )
      ) {
        navigate(ROUTES_PATH.PERSONAL_FINANCES_UNAVAILABLE, {
          state: { errorType: 'DRF0089' },
        });
      } else if (
        error &&
        error.response?.data?.result?.errors.find(
          (er: any) => er.code === 'DRF0092',
        )
      ) {
        //2º caso de error de Belender (jubilados)
        navigate(ROUTES_PATH.PERSONAL_FINANCES_UNAVAILABLE, {
          state: { errorType: 'DRF0092' },
        });
      } else {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };

  const handleMissingData = async (
    creditProposalMissing: CreditProposalResult,
    step?: string,
  ) => {
    if (step === 'DECISION_PAC') {
      getDecisionData(creditProposalMissing, 0, 'DECISION_PAC');
    } else {
      if (creditProposalMissing.customer?.customer_classification) {
        if (
          creditProposalMissing.customer.require_labor_data ||
          creditProposalMissing.customer.require_address_data
        ) {
          navigate(ROUTES_PATH.LABOR_DATA);
        } else {
          getDecisionData(creditProposalMissing, 0);
        }
      } else {
        getClassification(creditProposalMissing);
      }
    }
  };
  const verifyApiCall = async (
    counter: number,
    creditProposalIdVerify: string,
    isVerify: boolean,
  ) => {
    const count = counter;
    try {
      if (isVerify) {
        !isNemuru &&
          (await CreditProposalService.verifyBankreader(
            creditProposalIdVerify,
          ));
        AnalyticsService.verify();
        navigate(ROUTES_PATH.END);
      } else {
        !isNemuru &&
          (await CreditProposalService.activateCreditProposal(
            creditProposalIdVerify,
          ));
        navigate(ROUTES_PATH.END);
      }
    } catch (error: any) {
      const errorCode = error.response?.data.result.errors[0]?.code;
      if (
        error.result?.http_code === 422 &&
        errorCode === 'DRF0027' &&
        count < 3
      ) {
        setTimeout(() => {
          verifyApiCall(count + 1, creditProposalIdVerify, isVerify);
        }, 3000);
      } else {
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };

  const handleContinue = async () => {
    try {
      const creditProposalResultGET =
        await CreditProposalService.getCreditProposal(creditProposalResult.credit_proposal_id);
      createCreditProposalResult(creditProposalResultGET);

      if (creditProposalResultGET.status === 'ACT') {
        navigate(ROUTES_PATH.END);
      } else if (creditProposalResultGET.status === 'WTD') {
        navigate(ROUTES_PATH.DENIAL);
      } else {
        switch (creditProposalResultGET.flow_step) {
          case CreditProposalFlowStep.PAYMENT:
            navigate(ROUTES_PATH.PAYMENT);
            break;
          case CreditProposalFlowStep.OCR:
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              navigate(ROUTES_PATH.OCR);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case CreditProposalFlowStep.ESIGNATURE:
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              navigate(ROUTES_PATH.SIGNATURE);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case CreditProposalFlowStep.DECISION:
            handleMissingData(creditProposalResultGET);
            break;
          case CreditProposalFlowStep.DECISION_PAC:
            handleMissingData(creditProposalResultGET, 'DECISION_PAC');
            break;
          case CreditProposalFlowStep.ACTIVATION:
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              verifyApiCall(0, creditProposalResultGET.credit_proposal_id, false);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case CreditProposalFlowStep.VERIFICATION:
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              verifyApiCall(0, creditProposalResultGET.credit_proposal_id, true);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case CreditProposalFlowStep.CLASSIFICATION:
            getClassification(creditProposalResultGET);
            break;
          case CreditProposalFlowStep.UPDATE:
            navigate(ROUTES_PATH.LABOR_DATA);
            break;
          case CreditProposalFlowStep.UPDATE_IBAN:
          case CreditProposalFlowStep.BANK_READER:
            // BANK_READER
            if (customerDevice?.toLocaleLowerCase() === 'true') {
              navigate(ROUTES_PATH.BANKREADER);
            } else {
              navigate(ROUTES_PATH.OPERATION_SHIPPING);
            }
            break;
          case CreditProposalFlowStep.COUNTER_OFFER: // Contraoferta
            if (
              creditProposalResultGET.counter_offers &&
              creditProposalResultGET.counter_offers.length > 0
            ) {
              createCreditProposalResult({
                ...creditProposalResultGET,
                counter_offers: creditProposalResultGET.counter_offers,
                flow_step: CreditProposalFlowStep.COUNTER_OFFER,
              } as CreditProposalResult);
            }
            navigate(ROUTES_PATH.COUNTER_OFFER);
            break;
          case CreditProposalFlowStep.PERSONAL_FINANCES:
            navigate(ROUTES_PATH.PERSONAL_FINANCES);
            break;
          default:
            navigate(ROUTES_PATH.UNKNOWN_ERROR);
            break;
        }
      }

    } catch (error) {
      navigate(ROUTES_PATH.UNKNOWN_ERROR);
    }
  };



  const getHeaderFinancesUnavailable = () => {
    switch (errorType) {
      // Clasificación de cliente incorrecta
      case "DRF0089":
        return (
          <UnavailableContainer>
            <Title id="personal-finances-unavailable-title">
              Consulta a la Seguridad Social no disponible
            </Title>
            <Subtitle $align="left">
              Para completar la consulta, necesitamos actualizar la fecha de nacimiento o el teléfono en la Seguridad Social
            </Subtitle>
            <UnavailableLink href="https://peppercomercios.pepperfinance.es/actualiza-datos-seguridad-social" target="_blank" rel="noreferrer">
              Consulta aquí cómo realizar el proceso
            </UnavailableLink>
            <Subtitle $align="left">
              Si tienes dudas, llama a tu comercial a su móvil o al{" "}
              <TextTel $fontSize={14}>912 16 12 12</TextTel> para finalizar la
              financiación.
            </Subtitle>
          </UnavailableContainer>
        );
      case "DRF0092":
        return (
          <UnavailableContainer>
            <Title id="personal-finances-unavailable-title">
              Perfil del cliente no soportado
            </Title>
            <Subtitle $align="left">
              No es posible realizar las consultas necesarias por el perfil del
              cliente (jubilado/pensionista). Deberás tramitar la solicitud con
              Plus o Classic.
            </Subtitle>
            <UnavailableLink href="https://peppercomercios.pepperfinance.es/actualiza-datos-seguridad-social" target="_blank" rel="noreferrer">
              Consulta aquí cómo realizar el proceso
            </UnavailableLink>
            <Subtitle $align="left">
              Llama a tu comercial al{" "}
              <TextTel $fontSize={14}>912 16 12 12</TextTel> para más
              información
            </Subtitle>
          </UnavailableContainer>
        );
      // Constula no disponible
      case 'ERR':
        return (
          <UnavailableContainer>
            <Title id="personal-finances-unavailable-title" >
              Consulta a la Seguridad Social no disponible
            </Title>
            <Subtitle $align="left">
              La consulta a la seguridad social no está funcionando actualmente.
              No te preocupes, vamos a continuar con la tramitación con
              normalidad.
            </Subtitle>
          </UnavailableContainer>
        );
      default:
        return "";
    }
  };

  useEffect(() => {
    loadingEvent(false);
  }, [loadingEvent]);

  useEffect(() => {
    setisApp(ViewModeService.getViewMode() === "APP" ? true : false);
    setDevice(ViewModeService.getDevice());
  }, [isApp, device]);

  useEffect(() => {
    AnalyticsService.belenderUnavailable({
      type:
        errorType === "DRF0092"
          ? BelenderType.PROFILE
          : BelenderType.UNAVAILABLE,
    });
    if (isPostDataMessages) {
      PostMessageService.FinancingFailed(
        creditProposalResult?.credit_proposal_id,
      );
    }
  }, []);
  return (
    <>
      {getHeaderFinancesUnavailable()}
      <UnavailableImageWrapper>
        <UnavailableImage src={UnavailableImgSrc} />
      </UnavailableImageWrapper>
      {errorType === "ERR" ? (
        <MainButton
          id="personal-finances-unavailable-continue-btn"
          onClick={handleContinue}
        >
          Continuar
        </MainButton>
      ) : isApp && device === "ios" ? (
        <MainLink href="peppermerchants://home">Cerrar</MainLink>
      ) : (
        <MainButton
          id="personal-finances-unavailable-btn"
          onClick={handleClose}
        >
          Cerrar
        </MainButton>
      )}
    </>
  );
};
